export default {
  'eventEngine.title': '事件引擎',
  'eventEngine.subTitle': '檢視平台事件流水、訂閱關係與各消費者的消費情況',
  'eventEngine.forbidden.title': '無權存取事件引擎',
  'eventEngine.forbidden.subTitle':
    '此檢視跨租戶顯示平台事件，僅對企業管理員開放，請聯絡管理員開通。',

  'eventEngine.tab.events': '事件流水',
  'eventEngine.tab.consumptions': '消費記錄',
  'eventEngine.tab.subscriptions': '訂閱關係',

  'eventEngine.stat.totalEvents': '事件總數',
  'eventEngine.stat.pendingEvents': '待派送事件',
  'eventEngine.stat.failedConsumptions': '消費失敗與死信',
  'eventEngine.stat.activeSubscriptions': '生效訂閱',

  'eventEngine.field.type': '事件類型',
  'eventEngine.field.status': '狀態',
  'eventEngine.field.source': '來源服務',
  'eventEngine.field.subject': '事件對象',
  'eventEngine.field.tenantId': '租戶識別碼',
  'eventEngine.field.appId': '應用識別碼',
  'eventEngine.field.operatorId': '操作人識別碼',
  'eventEngine.field.eventversion': '事件版本',
  'eventEngine.field.ceId': '事件 ID',
  'eventEngine.field.consumer': '消費者',
  'eventEngine.field.pattern': '訂閱模式',
  'eventEngine.field.serviceName': '業務服務',
  'eventEngine.field.callbackUrl': '回呼位址',
  'eventEngine.field.retryCount': '重試次數',
  'eventEngine.field.lastError': '最近錯誤',
  'eventEngine.field.nextRetryAt': '下次重試時間',
  'eventEngine.field.consumedAt': '消費成功時間',
  'eventEngine.field.failedAt': '消費失敗時間',
  'eventEngine.field.deadAt': '進入死信時間',
  'eventEngine.field.publishedAt': '派送時間',
  'eventEngine.field.time': '事件發生時間',
  'eventEngine.field.occurredAt': '事件發生時間',
  'eventEngine.field.recordedAt': '記錄時間',
  'eventEngine.field.createdAt': '建立時間',
  'eventEngine.field.updatedAt': '更新時間',
  'eventEngine.field.action': '操作',
  'eventEngine.field.unknown': '未知',

  'eventEngine.placeholder.typePrefix': '依前綴比對，例如 tenant.',
  'eventEngine.placeholder.pattern': '例如 tenant.# 或 member.*',
  'eventEngine.placeholder.source': '全部來源服務',

  'eventEngine.action.detail': '詳情',
  'eventEngine.detail.eventTitle': '事件詳情',
  'eventEngine.detail.consumptionTitle': '消費記錄詳情',
  'eventEngine.detail.payload': '事件載荷',
  'eventEngine.detail.rawEvent': '完整事件',
  'eventEngine.detail.copyJson': '複製 JSON',
  'eventEngine.detail.copied': '已複製',
  'eventEngine.detail.emptyPayload': '該事件沒有載荷',
  'eventEngine.detail.lastError': '最近錯誤',

  'eventEngine.outboxStatus.pending': '待派送',
  'eventEngine.outboxStatus.published': '已派送',
  'eventEngine.outboxStatus.failed': '派送失敗',

  'eventEngine.inboxStatus.processing': '投遞中',
  'eventEngine.inboxStatus.consumed': '已消費',
  'eventEngine.inboxStatus.failed': '待重試',
  'eventEngine.inboxStatus.dead': '死信',

  'eventEngine.subscriptionStatus.active': '生效',
  'eventEngine.subscriptionStatus.disabled': '已停用',

  'eventEngine.action.retry': '重試',
  'eventEngine.retry.singleTitle': '確認重試？',
  'eventEngine.retry.singleConsumptionDesc':
    '該記錄將重新排隊投遞，已成功消費的會自動略過。',
  'eventEngine.retry.singleEventDesc':
    '該事件將重新投遞到訊息佇列，重複投遞會在消費端去重。',
  'eventEngine.retry.batchAction': '依篩選批次重試',
  'eventEngine.retry.batchTitle': '確認批次重試？',
  'eventEngine.retry.batchContent':
    '目前篩選條件共符合 {count} 筆記錄，其中僅可重試狀態的會被重新排隊，其餘保持不變。此操作無法復原。',
  'eventEngine.retry.confirm': '確認重試',
  'eventEngine.retry.cancel': '取消',
  'eventEngine.retry.success': '已重新排隊 {count} 筆記錄',

  'eventEngine.preset.last1Hour': '最近 1 小時',
  'eventEngine.preset.today': '今天',
  'eventEngine.preset.last24Hours': '最近 24 小時',
  'eventEngine.preset.last3Days': '最近 3 天',
  'eventEngine.preset.last7Days': '最近 7 天',

  'eventEngine.action.viewConsumptions': '檢視消費記錄',
  'eventEngine.action.viewSourceEvent': '檢視來源事件',
  'eventEngine.action.retrySelected': '重試所選 ({count})',
  'eventEngine.retry.selectedTitle': '確認重試選取的記錄？',
  'eventEngine.retry.selectedContent':
    '將重試選取的 {count} 筆記錄，已成功消費的會自動略過。',
  'eventEngine.retry.selectedSuccess':
    '批次重試完成：成功 {success} 筆，失敗 {failed} 筆',
  'eventEngine.retry.notRetryable': '目前狀態不可重試',
  'eventEngine.retry.inDrawerAction': '重試此記錄',

  'eventEngine.refresh.title': '重新整理統計',
  'eventEngine.refresh.lastUpdated': '更新於 {time}',
  'eventEngine.refresh.autoRefresh': '定時重新整理',
  'eventEngine.refresh.off': '關閉',
  'eventEngine.refresh.30s': '30秒',
  'eventEngine.refresh.60s': '60秒',

  'eventEngine.detail.searchPayload': '搜尋載荷內容...',
  'eventEngine.detail.downloadJson': '下載 JSON',
  'eventEngine.detail.wrapLines': '自動換行',
  'eventEngine.detail.expandError': '展開錯誤詳情',
  'eventEngine.detail.collapseError': '收起錯誤詳情',
  'eventEngine.stat.cardTip': '點擊可依此狀態篩選',

  'eventEngine.action.delete': '刪除',
  'eventEngine.subscription.deleteTitle': '確認刪除該訂閱？',
  'eventEngine.subscription.deleteDesc':
    '刪除後該消費者不再收到事件。訂閱由業務服務啟動時自動註冊，服務若仍在執行，下次重啟會重新註冊；待重試的消費記錄會在下次重試時轉為死信。',
  'eventEngine.subscription.confirm': '確認刪除',
  'eventEngine.subscription.deleted': '訂閱已刪除',
  'eventEngine.subscription.deleteMissing': '該訂閱已不存在，列表已重新整理',

  'eventEngine.delete.singleTitle': '確認刪除這筆死信？',
  'eventEngine.delete.singleDesc':
    '記錄將被永久刪除，該事件不會再補送給這個消費者。僅死信狀態可刪除。',
  'eventEngine.delete.batchAction': '批次刪除死信',
  'eventEngine.delete.batchTitle': '確認批次刪除死信？',
  'eventEngine.delete.batchContent':
    '目前篩選條件共符合 {count} 筆記錄，其中死信狀態的會被永久刪除，其餘保持不變。刪除後這些事件不會再補送給對應消費者，此操作無法復原。',
  'eventEngine.delete.confirm': '確認刪除',
  'eventEngine.delete.success': '已刪除 {count} 筆死信',
};
